import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";

export default function GovCustomers() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/gov/customers").then(r => setRows(r.data)).catch(e => toast.error(formatApiError(e)));
  }, []);

  return (
    <div className="space-y-4" data-testid="gov-customers">
      <div>
        <h1 className="font-heading text-3xl">Citizen Registry</h1>
        <p className="text-sm text-[#5C5A55] mt-1">Read-only · Jurisdiction-filtered</p>
      </div>

      <div className="bg-white border border-[#E5E2D9] rounded-md">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-[#F7F6F2] text-left text-[11px] uppercase tracking-[0.2em] text-[#5C5A55]">
              <th className="px-6 py-3">Code</th>
              <th className="px-6 py-3">Name</th>
              <th className="px-6 py-3">Phone</th>
              <th className="px-6 py-3">Status</th>
              <th className="px-6 py-3">Ward</th>
              <th className="px-6 py-3">Package</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={6} className="px-6 py-12 text-center text-[#8A8780]">No citizens in your jurisdiction.</td></tr>}
            {rows.map((c, i) => (
              <tr key={c.id} className={i % 2 === 0 ? "bg-white" : "bg-[#FAFAF7]"}>
                <td className="px-6 py-3 font-mono text-xs">{c.customer_code || "—"}</td>
                <td className="px-6 py-3 font-medium">{c.name}</td>
                <td className="px-6 py-3 font-mono text-xs">{c.phone}</td>
                <td className="px-6 py-3 capitalize">{c.status}</td>
                <td className="px-6 py-3 text-[#5C5A55]">{c.ward_id?.slice(0, 8) || "—"}</td>
                <td className="px-6 py-3 text-[#5C5A55]">{c.package_id?.slice(0, 8) || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
